import * as React from 'react';
import type { HelpTopic } from '@chess/api-help';

// The help topic behind the card's "?": how a middlegame that went wrong
// gets its cause, in plain words. Registered by this plugin's setup.
export const LOST_GROUND_HELP = 'middlegame.lost-ground';

export const lostGroundHelp: HelpTopic = {
  title: 'How you lost ground',
  body: (
    <>
      <p>
        This card looks at your middlegames of the last 30 days that went wrong: those that Middlegame results counts as <b>Blown advantage</b> or <b>Behind</b>.
        Each one gets one cause, from the whole middlegame rather than a single move.
      </p>
      <h3>What a move cost</h3>
      <p>
        Only your own moves count, and only those counted as a blunder or a miss under your Blunders and misses settings. Each costs win chance, in points of
        expected score (0–100 %): a blunder costs your chance before the move less your chance after it; a miss costs the chance the engine's best move would
        have kept less the chance of the move you played. A drop in a position that was already won or already lost changes your chance little, so it costs little.
      </p>
      <h3>The cause of a move</h3>
      <p>Each move takes the first cause that fits, in this order:</p>
      <ol>
        <li><b>Time</b>: you had under a minute left on your clock after it (only when the game records clock times).</li>
        <li><b>Missed chance</b>: a miss, a clearly better or winning move you didn't play.</li>
        <li><b>Tactic</b>: you allowed mate, left a piece hanging, walked into a fork, or lost material to another tactic.</li>
        <li><b>Positional</b>: none of those; a quiet move that cost a lot.</li>
      </ol>
      <h3>The cause of the game</h3>
      <p>
        The costs of all the counted moves are added up by cause, and the game takes the cause that cost the most in total. So a middlegame that slipped away
        through several small quiet mistakes is <b>Positional</b> even if it ended with a tactic. If two causes cost the same, the cause of the move that crossed
        from winning to level or from level to lost decides; failing that, the earlier move.
      </p>
      <p>A middlegame that went wrong without any counted mistake (for example a slow slide of small inaccuracies) has no cause and isn't in the pie.</p>
      <h3>Practice</h3>
      <p>Clicking a slice opens those games in the library. The move to practise in each game is the costliest move of its cause.</p>
    </>
  ),
};
